export default {
  'memberAsset.filter.source.all': '全部来源',
  'memberAsset.filter.source.upload': '上传资产',
  'memberAsset.filter.source.ai': 'AI 生成',
  'memberAsset.filter.dateRange.start': '选择开始日期',
  'memberAsset.filter.dateRange.end': '选择结束日期',
  'memberAsset.filter.type.all': '全部类型',
  'memberAsset.filter.type.text': '内容',
  'memberAsset.filter.type.image': '图片',
  'memberAsset.filter.type.video': '视频',
  'memberAsset.filter.type.audio': '音频',
  'memberAsset.empty': '暂无资产',
  'memberAsset.loadFailed': '资产列表加载失败',
  'memberAsset.loadingMore': '加载更多…',
  'memberAsset.noMore': '没有更多了',
  'memberAsset.preview.title': '预览',
  'memberAsset.download': '下载',
  'memberAsset.downloadFailed': '下载失败',
  'memberAsset.delete': '删除',
  'memberAsset.deleteSuccess': '删除成功',
  'memberAsset.deleteFailed': '删除失败，请重试',
};
